import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import qs from 'qs'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import highchartsMore from 'highcharts/highcharts-more'
import bellCurve from 'highcharts/modules/histogram-bellcurve'
import Blob from './Excel/Blob'
import Export2Excel from './Excel/Export2Excel.js'

// 全局使用 axios
axios.defaults.withCredentials = true
Vue.use(VueAxios, axios)
// 全局使用 qs
Vue.prototype.qs = qs
Vue.config.productionTip = false

// highchartsMore https://mlog.club/article/1549170
highchartsMore(Highcharts)
//常態分布圖
bellCurve(Highcharts)
Vue.use(HighchartsVue, { Highcharts })

Vue.component(VueQrcode.name, VueQrcode)
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
